<div class="delete-order-dialog">
  <header class="dialog-header dialog-header--danger">
    <div class="dialog-header__icon" aria-hidden="true">
      <mat-icon>delete_outline</mat-icon>
    </div>
    <div class="dialog-header__text">
      <h2 mat-dialog-title>Eliminar Orden de Servicio</h2>
      <p *ngIf="contextLabel" class="dialog-header__context">{{ contextLabel }}</p>
    </div>
  </header>

  <mat-dialog-content class="dialog-body" *ngIf="state === 'confirm'">
    <div class="summary-card summary-card--danger">
      <div class="summary-card__count">N°</div>
      <div class="summary-card__info">
        <strong>{{ orderNumber || '—' }}</strong>
        <span>{{ serviceName }} · {{ providerName }}</span>
      </div>
      <span
        class="os-status"
        [attr.data-os-status]="(orderStatus || '').toUpperCase()"
      >
        {{ orderStatus || '—' }}
      </span>
    </div>

    <ul class="os-meta" *ngIf="reservationNumber || reservationStatus">
      <li *ngIf="reservationNumber">Reserva: {{ reservationNumber }}</li>
      <li *ngIf="reservationStatus">Estado reserva: {{ reservationStatus }}</li>
    </ul>

    <p *ngIf="affectedServicesCount > 1" class="impact-note">
      Se liberarán <strong>{{ affectedServicesCount }} servicios</strong> vinculados
      a esta OS.
    </p>

    <div class="alert alert--warn">
      <mat-icon>warning_amber</mat-icon>
      <span>Esta acción es irreversible. El servicio quedará disponible para generar una nueva OS.</span>
    </div>
  </mat-dialog-content>

  <mat-dialog-content class="dialog-body dialog-body--center" *ngIf="state === 'loading'">
    <mat-spinner [diameter]="40"></mat-spinner>
    <p class="state-title">Eliminando Orden de Servicio</p>
    <p class="state-subtitle">N° {{ orderNumber }}</p>
  </mat-dialog-content>

  <mat-dialog-content class="dialog-body" *ngIf="state === 'error'">
    <div class="alert alert--error">
      <mat-icon>error_outline</mat-icon>
      <div>
        <strong *ngIf="errorTitle">{{ errorTitle }}</strong>
        <span>{{ errorMessage }}</span>
      </div>
    </div>
    <p *ngIf="errorRequiresRefresh" class="impact-note">
      La grilla puede estar desactualizada. Al continuar se consultará de nuevo el backend.
    </p>
  </mat-dialog-content>

  <mat-dialog-content class="dialog-body" *ngIf="state === 'blocked'">
    <div class="alert alert--error">
      <mat-icon>block</mat-icon>
      <span>{{ blockedMessage }}</span>
    </div>

    <div class="summary-card summary-card--muted">
      <div class="summary-card__count">N°</div>
      <div class="summary-card__info">
        <strong>{{ orderNumber || '—' }}</strong>
        <span>{{ serviceName }}</span>
      </div>
      <span
        class="os-status"
        [attr.data-os-status]="(orderStatus || '').toUpperCase()"
      >
        {{ orderStatus || '—' }}
      </span>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions" *ngIf="state === 'confirm'">
    <button mat-stroked-button type="button" class="do-btn do-btn--ghost" (click)="cancel()">
      Cancelar
    </button>
    <button
      mat-flat-button
      type="button"
      class="do-btn do-btn--danger"
      (click)="confirmDelete()"
    >
      Eliminar OS
    </button>
  </mat-dialog-actions>

  <mat-dialog-actions class="dialog-actions" *ngIf="state === 'error' && !errorRequiresRefresh">
    <button mat-stroked-button type="button" class="do-btn do-btn--ghost" (click)="cancel()">
      Cancelar
    </button>
    <button mat-flat-button type="button" class="do-btn do-btn--danger" (click)="retry()">
      Reintentar
    </button>
  </mat-dialog-actions>

  <mat-dialog-actions class="dialog-actions" *ngIf="state === 'error' && errorRequiresRefresh">
    <button mat-flat-button type="button" class="do-btn do-btn--primary" (click)="cerrarYActualizar()">
      Entendido y actualizar
    </button>
  </mat-dialog-actions>

  <mat-dialog-actions class="dialog-actions" *ngIf="state === 'blocked'">
    <button mat-flat-button type="button" class="do-btn do-btn--primary" (click)="dismissBlocked()">
      Entendido
    </button>
  </mat-dialog-actions>
</div>
